import { render, staticRenderFns } from "./AdminClients.vue?vue&type=template&id=10e1d804"
import script from "./AdminClients.vue?vue&type=script&lang=js"
export * from "./AdminClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports